import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/legalentity-general-types/legalentity/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchLegalEntityTenantsNoSuspense =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useQuery
